<template>
    <li class="accordion__item">
        <div class="accordion__trigger" :class="{ 'accordion__trigger_active': visible }" @click="open">
            <!-- This slot will handle the title/header of the accordion and is the part you click on -->
            <i class="fa" :class="visible ? 'fa-minus' : 'fa-plus'"></i>
            <slot name="accordion-trigger"></slot>
        </div>

        <transition name="accordion" @enter="start" @after-enter="end" @before-leave="start" @after-leave="end">
            <div class="accordion__content__container" v-show="visible">
                <!-- This slot will handle all the content that is passed to the accordion -->
                <div class="accordion__content">
                    <slot name="accordion-content"></slot>
                </div>
            </div>
        </transition>
    </li>
</template>


<script>
export default {
    props: {
        name: {
            type: String,
            required: false
        }
    },
    inject: ["Accordion"],
    data() {
        return {
            index: null
        };
    },
    computed: {
        visible() {
            return this.index == this.Accordion.active;
        }
    },
    methods: {
        open() {
            if (this.visible) {
                this.Accordion.active = null;
            } else {
                this.$emit('opened', this.name);
                this.Accordion.active = this.index;
            }
        },
        start(el) {
            el.style.height = el.scrollHeight + "px";
        },
        end(el) {
            el.style.height = "";
        }
    },
    created() {
        this.index = this.Accordion.count++;
    }
};
</script>

<style lang="scss">
@import './assets/scss/frontend/base/colour_vars.scss';
.accordion__item {
    position: relative;
    margin-bottom: 1rem;
}

.accordion__trigger {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    padding: 16px;
    background: $accordion-item-bg-color;
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: flex-start;
    border: 1px solid lightgray;
}


.accordion__content__container>.accordion__content {
    padding-top: 1rem;
}

.accordion-enter-active,
.accordion-leave-active {
    will-change: height, opacity;
    transition: height 0.3s ease, opacity 0.3s ease;
    overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
    height: 0 !important;
    opacity: 0;
}
</style>
